import React from "react";
import { useSnapshot } from "valtio";

import {
    designStore,
    setActionsButtonsItems,
    generalConfigStore,
} from "@store";
import {
    ACCOUNT_CREATION_BUTTON_ROLE,
    BACK_BUTTON_ROLE,
    IGNORE_BUTTON_ROLE,
} from "@constants/index";
import { selectIsLoyaltyStep } from "@helpers/general";

import { ActionsButtonsWrapper } from "@components/Common/Design/ActionsButtonsWrapper";

export function ActionsButtons(): JSX.Element {
    const { activePageName } = useSnapshot(designStore);
    const {
        project: {
            template: { pages },
        },
    } = useSnapshot(generalConfigStore);

    const { ways } = pages;

    // Lu depuis le snapshot Valtio (et non le store brut) → réactif au toggle.
    const isLoyaltyStep = selectIsLoyaltyStep(pages);

    // Rôles affichés dans l'onglet "Actions Buttons" de la page authenticationModes.
    // Le bouton "Créer un compte" (ACCOUNT_CREATION_BUTTON_ROLE) n'est listé que
    // lorsque l'étape fidélité (loyaltyStep) est active.
    const roles = isLoyaltyStep
        ? [BACK_BUTTON_ROLE, IGNORE_BUTTON_ROLE, ACCOUNT_CREATION_BUTTON_ROLE]
        : [BACK_BUTTON_ROLE, IGNORE_BUTTON_ROLE];

    const [filteredItems, setFilteredItems] = React.useState<
        ActionsButtonsDesignItemType[]
    >(
        (ways[activePageName] as PageType).actionsButtons.items.filter(
            (item: ActionsButtonsDesignItemType) => roles.includes(item.role)
        )
    );

    React.useEffect(() => {
        const items = (ways[activePageName] as PageType).actionsButtons.items.filter(
            (item: ActionsButtonsDesignItemType) => roles.includes(item.role)
        );
        setFilteredItems(items);
        setActionsButtonsItems(items);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoyaltyStep, activePageName]);

    return (
        <ActionsButtonsWrapper
            localActionsButtonsItems={filteredItems}
            setLocalActionsButtonsItems={setFilteredItems}
        />
    );
}
